import { render } from "./ProbsetPage.vue?vue&type=template&id=a32a9a24"
import script from "./ProbsetPage.vue?vue&type=script&lang=js"
export * from "./ProbsetPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__